import { render, staticRenderFns } from "./userPerms.vue?vue&type=template&id=27b97c7b&"
import script from "./userPerms.vue?vue&type=script&lang=js&"
export * from "./userPerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports